import React, {useEffect, useState} from 'react';
import {Alert, Button, Card, Col, Form, Input, message, Row} from "antd";

const Config: React.FC = () => {
  const [config, setConfig] = useState<Record<string, string>>({});
  const [userInfo, setUserInfo] = useState<Record<string, string>>({});
  const [cardNo, setCardNo] = useState('');
  const [cardPass, setCardPass] = useState('');

  const updateUserInfo = () => {
    fetch('/login/info', {
      method: 'GET',
    }).then(res => res.json()).then((e) => {
      console.info(e)
      if (e.isSuccess) {
        setConfig(JSON.parse(e.detail?.config || '{}'));
        console.info('data is ', e.detail);
        setUserInfo(e.detail);
      }
    })
  }

  useEffect(() => {
    updateUserInfo();
  }, [])

  const [saving, setSaving] = useState(false)

  const handleSave = () => {
    console.info('handleSave', config)
    message.warning("功能开发中")
    setSaving(true);
    fetch('/login/active', {
      method: 'POST',
      body: JSON.stringify({
        cardNo,
        cardPass
      }),
      headers: {
        'Content-Type': 'application/json;charset=utf8'
      }
    }).then(res => res.json()).then((data) => {
      console.info('flag is', data);
      if (data.success || data.isSuccess) {
        message.info('激活成功，请刷新页面')
        updateUserInfo();
      } else {
        message.error(data.message || "激活失败")
      }
    }).finally(() => {
      setSaving(false);
    })
  }

  console.info('user is', userInfo);
  if (userInfo.isActiveVip) {
    const text = `您已经是 VIP 了，可以尽情使用。过期时间： ${userInfo.vipEndTime || '-'}`;
    return (
      <>
        <Alert message={text} type="success"/>
      </>
    )
  }

  return (
    <>
      <Form>
        <Row gutter={16}>
          <Col span={8}>
            <Card title="一天会员 5 块钱（支付宝扫码）">
              <img src={"https://z.wiki/autoupload/20241017/kIaG/450X442/image.png"} style={{maxWidth: '100%'}}/>
            </Card>
          </Col>
          <Col span={8}>
            <Card title="一个月会员 20 块钱（支付宝扫码）">
              <img src={"https://z.wiki/autoupload/20241017/BCcM/464X442/image.png"} style={{maxWidth: '100%'}}/>
            </Card>
          </Col>
          <Col span={8}>
            <Card title="购买后获取卡号密码">
              <a target={"_blank"} href={"https://cdn.z.wiki/autoupload/20241017/9UVf/744X1614/image.png"}>
                点击放大查看
                <img src={"https://cdn.z.wiki/autoupload/20241017/9UVf/744X1614/image.png"}
                     style={{maxWidth: '50%', margin: '0 auto'}}/>
              </a>
            </Card>
          </Col>
        </Row>
        <br/>
        <Alert type={'info'} message={"请扫描二维码购买VIP后输入卡号密码激活VIP，支付后的界面中有卡号和密码"}/>
        <br/>
        <Form.Item label="卡号">
          <Input placeholder="请输入卡号" value={cardNo}
                 onChange={(e) => setCardNo(e.target.value)}/>
        </Form.Item>
        <Form.Item label="密码">
          <Input placeholder="请输入密码" value={cardPass}
                 onChange={(e) => setCardPass(e.target.value)}/>
        </Form.Item>
        <Form.Item>
          <Button type="primary" loading={saving} onClick={handleSave}>保存</Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default Config;